import { render, staticRenderFns } from "./SmsBotSettings.vue?vue&type=template&id=22891684&scoped=true&"
import script from "./SmsBotSettings.vue?vue&type=script&lang=js&"
export * from "./SmsBotSettings.vue?vue&type=script&lang=js&"
import style0 from "./SmsBotSettings.vue?vue&type=style&index=0&id=22891684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22891684",
  null
  
)

export default component.exports